import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

/**
 * Lets feature UIs temporarily hide the global SAI Assistant launcher
 * (`ChatWidgetComponent`) — e.g. while a side agent drawer is open so two
 * chat FABs do not stack in the same corner.
 *
 * Visibility is still gated by `AppComponent` (signed-in + allowed route);
 * this subject is an extra suppress layer on top.
 */
@Injectable({ providedIn: 'root' })
export class ChatWidgetVisibilityService {
    private readonly _suppressed$ = new BehaviorSubject<boolean>(false);

    readonly suppressed$: Observable<boolean> = this._suppressed$.asObservable();

    get suppressed(): boolean {
        return this._suppressed$.value;
    }

    setSuppressed(suppressed: boolean): void {
        if (this._suppressed$.value === suppressed) {
            return;
        }
        this._suppressed$.next(suppressed);
    }
}
